import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Global, BaoCao } from '../../../shared/global';
import { Repository } from '../../../services/repository'
import { FilterService, ToolbarService, SelectionService, SortService, GridComponent } from '@syncfusion/ej2-angular-grids';
import 'jquery'
import 'bootstrap'
import { Observable } from 'rxjs';
import { retry } from 'rxjs-compat/operator/retry';
const swal = require('sweetalert');
@Component({
  selector: 'app-tonghop-choncauhoiedit',
  templateUrl: './choncauhoiedit.component.html',    
  styleUrls: ['./choncanboedit.component.scss'],
  providers: [ListService, Repository, ToolbarService, SelectionService, FilterService, SortService]
})


export class choncauhoieditComponent implements OnInit {

  @Output() savect: EventEmitter<any> = new EventEmitter();
  @ViewChild('grid') public grid: GridComponent;
  
  //------------khai bao control
  public pageSettings: Object;
  public selectOptions: Object;
 
  public filterSettings: Object;

  datas: any = [];

  //-----------------cac hàm khởi tạo dữ liệu ban đầu
  constructor(private fb: FormBuilder, private _dataService: ListService, public repo: Repository) {
    this.filterSettings = { type: 'Excel' };
    this.selectOptions = { persistSelection: true };
    this.pageSettings = { pageCount: 5, pageSizes: true, pageSize: 10 };
  }

  // @HostListener('document:keydown', ['$event'])
  public innerHeight: any
  
  loadDataInit( donvi: string, user_name: string) {
    this.repo.postRequest("api/cauhoi/getviewsearch", { DonViId: donvi, UserName: user_name, GhiChu: null })
      .subscribe(response => {
        this.datas = response;
      }); 
   
    
  }
  
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
  ngOnInit(): void {
   
  }

  public savectu() {
    this.savect.emit(this.grid.getSelectedRecords());

  }
 

  

}
